import { useTranslation } from '@kc-console/core';

export const useScopeLabel = () => {
  const { t } = useTranslation();

  return {
    project: t('layout:scope.project'),
    domain: t('layout:scope.domain'),
  } as const;
};
